import { StateSelector } from '@integration-frontends/common/utils/redux';
import { Container, SearchFilter } from '@integration-frontends/integration/core/model';
import { EntityState } from '@reduxjs/toolkit';
import { compose, equals, prop } from 'ramda';
import { createSelector } from 'reselect';
import { searchFilterAdapter } from '../entities/search-filter';

export function createSearchFilterSelectors(
  stateSelector: StateSelector<EntityState<SearchFilter>>,
) {
  const baseSelectors = searchFilterAdapter.getSelectors(stateSelector);
  const byContainer = (container: Container) =>
    createSelector(baseSelectors.selectAll, (entities) =>
      entities.filter(compose(equals(container?.id), prop('containerId'))),
    );

  return {
    ...baseSelectors,
    byContainer,
  };
}
